import { epoch, utc } from '../../util/datetime';
import { toUUID } from '../../util/transform';
import { PropertyDetailsType } from './PropertyDetails.enum';
import type { IPropertyDetails } from './PropertyDetails.interface';

export default class PropertyDetails {
  idOwner: string;
  propertyId: string;
  locationId: string;
  type: PropertyDetailsType;
  timeStamp: number;

  static build = (data: IPropertyDetails) => new PropertyDetails(data);
  static blank = () => new PropertyDetails();

  /**
   * Constructor
   * @param {IPropertyDetails} data
   */
  constructor(data?: IPropertyDetails) {
    this.idOwner = toUUID(data?.idOwner);
    this.propertyId = data?.propertyId || undefined;
    this.locationId = data?.locationId || undefined;
    this.type = PropertyDetailsType.of(data?.type?.name);
    this.timeStamp = data?.timeStamp ? epoch(utc(data?.timeStamp)) : 0;
  }
}
